import React from "react";

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
}
//message - Thank you for your submission, we will be in touch soon.
const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 animate-fadeIn">
      <div
        className="
          relative w-full max-w-md p-6 bg-white rounded-2xl shadow-xl
          animate-scaleIn
        "
      >
        <button
          className="absolute top-2 right-3 text-gray-400 hover:text-gray-600 transition"
          onClick={onClose}
        >
          ✕
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center text-xl font-semibold text-gray-800">
          Thank you for your submission!
        </h2>

        {/* Subtitle */}
        <p className="mt-2 text-center text-gray-500">
          We will be in touch soon.
        </p>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0.94); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        .animate-fadeIn {
          animation: fadeIn 0.25s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.25s ease-out;
        }
      `}</style>
    </div>
  );
};

export default SuccessModal;
